var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders } from "../utils/apiUtils";
import { MAX_LIST_LIMIT } from "../utils/fetchAllPages";
export var fetchLegalPersons = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var query, _a, offset, _b, limit, baseQuery, searchParams, response, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                query = filters.query, _a = filters.offset, offset = _a === void 0 ? 0 : _a, _b = filters.limit, limit = _b === void 0 ? MAX_LIST_LIMIT : _b;
                baseQuery = query || "cql.allRecords=1";
                searchParams = new URLSearchParams();
                searchParams.set("query", "".concat(baseQuery, " sortBy name residence"));
                searchParams.set("offset", String(offset));
                searchParams.set("limit", String(limit));
                return [4 /*yield*/, kyInstance.get("legal-persons", {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _c.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _c.sent()];
            case 3:
                error_1 = _c.sent();
                console.error("Error fetching legalPersons:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchLegalPersonById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get("legal-persons/".concat(id), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_2 = _a.sent();
                console.error("Error fetching legalPerson by ID:", error_2);
                throw error_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var createLegalPerson = function (kyInstance, legalPerson) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post("legal-persons", {
                        json: legalPerson,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Create error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                console.error("Error creating legalPerson:", error_3);
                throw error_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var updateLegalPerson = function (kyInstance, legalPerson) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                if (!legalPerson.id) {
                    throw new Error("LegalPerson ID is required for update");
                }
                return [4 /*yield*/, kyInstance.put("legal-persons/".concat(legalPerson.id), {
                        json: legalPerson,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Update error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_4 = _a.sent();
                console.error("Error updating legalPerson:", error_4);
                throw error_4;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var deleteLegalPerson = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.delete("legal-persons/".concat(id), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Delete error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_5 = _a.sent();
                console.error("Error deleting legalPerson:", error_5);
                throw error_5;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var reportLegalPersonChange = function (kyInstance, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.post("legal-persons/report-change", {
                        json: request,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Report change error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_6 = _a.sent();
                console.error("Error reporting legal person change:", error_6);
                throw error_6;
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Sends a local-only (unlinked) legal person to NK authorities (Aleph). A failed send
 * still answers 200; the returned person then carries `authoritySendError`.
 */
export var sendLegalPersonToAuthority = function (kyInstance, id, biographicalNote) { return __awaiter(void 0, void 0, void 0, function () {
    var body, response, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                body = biographicalNote
                    ? { biographicalNote: biographicalNote }
                    : undefined;
                return [4 /*yield*/, kyInstance.post("legal-persons/".concat(id, "/send-to-authority"), {
                        json: body,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Send to authority error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_7 = _a.sent();
                console.error("Error sending legal person to authority:", error_7);
                throw error_7;
            case 4: return [2 /*return*/];
        }
    });
}); };
/** Links an unlinked legal person to an existing NK authority record by its identifier. */
export var assignLegalPersonAuthorityId = function (kyInstance, id, authorityId) { return __awaiter(void 0, void 0, void 0, function () {
    var request, response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                request = { authorityId: authorityId };
                return [4 /*yield*/, kyInstance.put("legal-persons/".concat(id, "/authority-id"), {
                        json: request,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Assign authority id error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_8 = _a.sent();
                console.error("Error assigning authority id to legal person:", error_8);
                throw error_8;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Merges a local-only legal person into an existing one: its title contributions move
 * to the target and the source person is deleted. Returns the target person.
 */
export var mergeLegalPersonInto = function (kyInstance, id, targetId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post("legal-persons/".concat(id, "/merge-into/").concat(targetId), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Merge error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_9 = _a.sent();
                console.error("Error merging legal person:", error_9);
                throw error_9;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Proposes to the NK authority department, by e-mail, that the legal person (linked to an NK
 * authority) be merged into the target legal person linked to an NK authority (DB-756). The
 * person disappears, the target stays; nothing changes in ReČeK. A blank note is not sent.
 */
export var proposeLegalPersonMerge = function (kyInstance, id, targetId, note) { return __awaiter(void 0, void 0, void 0, function () {
    var trimmed, body, response, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                trimmed = note === null || note === void 0 ? void 0 : note.trim();
                body = trimmed
                    ? { note: trimmed }
                    : undefined;
                return [4 /*yield*/, kyInstance.post("legal-persons/".concat(id, "/propose-merge/").concat(targetId), {
                        json: body,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Merge proposal error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_10 = _a.sent();
                console.error("Error proposing a merge of legal persons:", error_10);
                throw error_10;
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Merges duplicate legal persons without an NK identifier into the opened one in one
 * transaction (DB-653): their title contributions, missing data, names and identifiers move
 * to it and they are deleted. Returns the opened person after the merge.
 */
export var mergeLegalPersonDuplicates = function (kyInstance, id, sourceIds) { return __awaiter(void 0, void 0, void 0, function () {
    var body, response, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                body = { sourceIds: sourceIds };
                return [4 /*yield*/, kyInstance.post("legal-persons/".concat(id, "/merge-duplicates"), {
                        json: body,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Merge duplicates error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_11 = _a.sent();
                console.error("Error merging legal person duplicates:", error_11);
                throw error_11;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Legal persons that look like duplicates of the given one (same name, ignoring case,
 * diacritics and whitespace) and may be merged into it (DB-653). The backend omits
 * empty arrays, so a missing `items` means no candidates.
 */
export var fetchLegalPersonMergeCandidates = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, body, error_12;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get("legal-persons/".concat(id, "/merge-candidates"), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _b.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                body = _b.sent();
                return [2 /*return*/, (_a = body === null || body === void 0 ? void 0 : body.items) !== null && _a !== void 0 ? _a : []];
            case 3:
                error_12 = _b.sent();
                console.error("Error fetching legal person merge candidates:", error_12);
                throw error_12;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Titles in which the legal person appears as a title contribution, with its roles
 * there; already filtered by the caller's title visibility and sorted by name.
 * The backend omits empty arrays, so a missing `items` means no titles.
 */
export var fetchLegalPersonTitles = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, body, error_13;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get("legal-persons/".concat(id, "/titles"), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _b.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                body = _b.sent();
                return [2 /*return*/, (_a = body === null || body === void 0 ? void 0 : body.items) !== null && _a !== void 0 ? _a : []];
            case 3:
                error_13 = _b.sent();
                console.error("Error fetching titles of legal person:", error_13);
                throw error_13;
            case 4: return [2 /*return*/];
        }
    });
}); };
